/* BM mobile carousel dots: dot indicators for the scroll-snap carousels
   (journey steps, segment lanes) below 750px. Manual navigation only –
   there is no timer and no auto-advance code path. Dots scroll instantly
   under prefers-reduced-motion. Dots are hidden at desktop by CSS.
   (S21) perPage option: dots represent pages of N items (segment lanes run
   three per view, so five lanes page as 3 + 2 and get two dots). */
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (container, opts = {}) => {
    if (!container || container.dataset.bmDots) return;
    const slides = [...container.children];
    const perPage = opts.perPage || 1;
    const pages = Math.ceil(slides.length / perPage);
    if (pages < 2) return;
    container.dataset.bmDots = 'true';

    const dots = document.createElement('div');
    dots.className = 'bm-scroll-dots';
    for (let i = 0; i < pages; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bm-scroll-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) dot.setAttribute('aria-current', 'true');
      const target = slides[Math.min(i * perPage, slides.length - 1)];
      dot.addEventListener('click', () => {
        container.scrollTo({
          left: target.offsetLeft - container.offsetLeft,
          behavior: REDUCED.matches ? 'auto' : 'smooth',
        });
      });
      dots.appendChild(dot);
    }
    /* (Launch fix, 12 Oct) Dots go after Dawn's prev/next row when the
       carousel has one, so Dawn's ".slider + .slider-buttons" desktop
       hide still matches. Inserting directly after the grid broke that
       rule and left a dead "1/2" counter under the experiments row at
       990px and wider. */
    const next = container.nextElementSibling;
    const anchor = next && next.classList.contains('slider-buttons') ? next : container;
    anchor.insertAdjacentElement('afterend', dots);

    const update = () => {
      const step = Math.max(1, slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 1);
      const index = Math.min(pages - 1, Math.round(container.scrollLeft / (step * perPage)));
      [...dots.children].forEach((dot, j) => {
        if (j === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    container.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
  };

  const boot = () => {
    init(document.querySelector('.mf-journey__steps'));
    init(document.querySelector('[id$="__segment-lanes"] .multicolumn-list'), { perPage: 3 });
    init(document.querySelector('[id$="__timely-strip"] .multicolumn-list'));
    init(document.querySelector('[id$="__experiments"] .product-grid'));
    /* (Launch fix, 12 Oct) Signature row: two coffees per view on phones,
       so four page as 2 + 2. */
    init(document.querySelector('[id$="__daily-ritual"] .product-grid'), { perPage: 2 });
    /* (S26) Subscription landing: benefit card tiles and recommendation
       cards page 1-up below 750px. */
    init(document.querySelector('.mf-subsplit--card .mf-subsplit__grid'));
    init(document.querySelector('.mf-sub-recs__grid'));
    /* (15 Oct) PDP trust strip (every product template keyed "trust"):
       dots replace Dawn's "1/4" counter on phones, matching the homepage
       carousels. Only attaches when the strip is a slider (Dawn adds the
       slider markup when swipe_on_mobile is on). */
    init(document.querySelector('[id$="__trust"] .multicolumn-list.slider'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
